import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { FormattedMessage } from 'react-intl';

import { Pluggable } from '@folio/stripes/core';

const BarcodeGeneralSettings = ({ match }) => {
  return (
    <Pluggable
      type="inventory-templates"
      basePath={match.path}
      redirectTo="general-settings"
    >
      <FormattedMessage id="ui-inventory.templatesPluginNotAvailable" />
    </Pluggable>
  );
};

BarcodeGeneralSettings.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
};

export default BarcodeGeneralSettings;
